const DefaultConfig = {
	admobAppId_Android: 'ca-app-pub-2191584882036728~3869769284'
	, admobInterstitialAdId_Android: 'ca-app-pub-2191584882036728/2018864088'
	, admobRewardedAdId_Android: 'ca-app-pub-2191584882036728/6965941561'
	, admobAppOpenAdId_Android: 'ca-app-pub-2191584882036728/9826804772'
	, admobAppId_iOS: 'ca-app-pub-2191584882036728~6588664488'
	, admobInterstitialAdId_iOS: 'ca-app-pub-2191584882036728/8065397685'
	, admobRewardedAdId_iOS: 'ca-app-pub-2191584882036728/3826936047'
	, admobAppOpenAdId_iOS: 'ca-app-pub-2191584882036728/9891750930'
	, admobid_windows: 'ca-app-pub-2191584882036728/4565044480'
	, facebookAdId_interstital: "401658098090396_405200211069518"
	, facebookAdId_reward: "401658098090396_405200294402843"
	, googleH5_ad_client: "ca-pub-2191584882036728"
	, googleH5_ad_channel: "8066744040"
	, offsetStartdelay: 120  //start with 1 min passed to get the first ad to show faster
	, delayBetweenAds: 240  //check for  240 (4 min) seconds passed was 180
	, delayBetweenRewardedAds: 300  //check for  600 seconds passed 
	, awayResetTime: 1200  //check if over 20 min, may have not been in the app and reopened it with out restarting 
	, ironSourceAndroidAppId: '1fa793bfd' //'85460dcd' is the testing app id
	, ironSourceIosAppId: '1fa790275' //'85460dcd' is the testing app id

};
export default DefaultConfig;
